/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Widget from '../../widget';
import { useNodes } from '../../../../components/dashboards/components/SupplyChainMap/useNodesOld';
import Style from './style';
import ReactFlow, { Background, ControlButton, Controls, ReactFlowProvider } from 'react-flow-renderer';
import { RotateLeftOutlined, RotateRightOutlined } from '@ant-design/icons';
import Sider from './sidebar';
import { DashboardService } from '../../../../services';
import ComponentWithFocus from '../../components/component-with-focus';
import { openDSWindow } from '../../../../helpers/Window';

const isAnalysis = true;
const getMinesites = (config, data = {}, activeSources = []) => {
  if (config && Array.isArray(config.parents) && config.parents.length) {
    config.parents.forEach(p => {
      if (p.type === 'mineSite') {
        if (!data[p.id] && p.sources && Array.isArray(p.sources) && activeSources.filter(s => p.sources.includes(s)).length) {
          data[p.id] = p;
        }
      } else {
        data = getMinesites(p, data, activeSources);
      }
    })
  }
  return data;
}

const getSuppliers = (config, data = {}, activeSources = []) => {
  if (config && Array.isArray(config.parents) && config.parents.length) {
    config.parents.forEach(p => {
      if (p.type !== 'mineSite') {
        const { parents, children, ...supplier } = p;
        if (!data[p.id] && p.sources && Array.isArray(p.sources) && activeSources.filter(s => p.sources.includes(s)).length) {
          data[p.id] = supplier;
        }
        data = getSuppliers(p, data, activeSources);
      }
    })
  }
  return data;
}

const getCustomers = (config, data = {}, activeSources = []) => {
  if (config && Array.isArray(config.children) && config.children.length) {
    config.children.forEach(p => {
      if (p.type !== 'mineSite') {
        const { parents, children, ...supplier } = p;
        if (!data[p.id] && p.sources && Array.isArray(p.sources) && activeSources.filter(s => p.sources.includes(s)).length) {
          data[p.id] = supplier;
        }
        data = getCustomers(p, data, activeSources);
      }
    })
  }
  return data;
}
export default function TradeRelationship({
  data = {},
  featuredData = [],
  informationSources = [],
  supplyChainActors = [],
  activeSources = [],
  getRedirectLink = () => { },
  isSingleSource = true,
  setTradeData = () => { },
  mode,
  loading = false,
}) {
  const { t } = useTranslation();
  const [activeNode, setActiveNode] = useState(null);
  const [flow, setFlow] = useState('TB');
  const [isLoading, setIsLoading] = useState(false);
  const [elementData, setElementData] = useState({});
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    if (data && data.apiCall) {
      setIsLoading(true);
      DashboardService.getSupplyChainMap(data.datastakeId, false, activeSources).then((res) => {
        if (res.data && Object.keys(res.data).length) {
          setElementData(res.data);
          setTradeData({
            mineSites: Object.values(getMinesites(res.data, {}, activeSources)),
            suppliers: Object.values(getSuppliers(res.data, {}, activeSources)),
            customers: Object.values(getCustomers(res.data, {}, activeSources)),
          });
        } else {
          setElementData({});
          setTradeData({
            mineSites: [],
            suppliers: [],
            customers: [],
          });
        }
        setIsLoading(false);
      }).catch(err => {
        setElementData({});
        setTradeData({
          mineSites: [],
          suppliers: [],
          customers: [],
        });
        setIsLoading(false);
      })
    } else {
      setElementData({});
      setTradeData({
        mineSites: [],
        suppliers: [],
        customers: [],
      });
    }
  }, [data]);

  const {
    elements,
    onConnect,
    onElementsRemove,
    onLoad,
    initElements,
  } = useNodes({
    data: elementData,
    setActiveNode,
    t,
    supplyChainActors,
    informationSources,
    ownDataSources: featuredData,
    activeNode,
    flow,
    activeSources,
    isAnalysis,
  });

  const actions = useMemo(() => ({
    closed,
    setClosed,
    unFocus: () => setActiveNode(null),
  }), [closed]);

  const clear = () => {
    setClosed(true);
    setActiveNode(null);
  };

  return (
    <Widget
      loading={isLoading || loading}
      title={t('Trade Relationships')}
    >
      <ComponentWithFocus
        actions={actions}
      >
        <Style>
          <ReactFlowProvider>
            <ReactFlow
              className="trade-relationship"
              elements={elements.length ? elements : []}
              onElementsRemove={onElementsRemove}
              onConnect={onConnect}
              onLoad={onLoad}
              selectNodesOnDrag={false}
              draggable={false}
              nodesDraggable={false}
              nodesConnectable={false}
              onElementClick={(e) => {
                if (initElements && Array.isArray(initElements)) {
                  if (e.currentTarget && e.currentTarget.getAttribute) {
                    const id = e.currentTarget.getAttribute('data-id');
                    const node = initElements.find((el) => el.id === id);
                    if (node) {
                      setActiveNode(node.config);
                      if (node.config.namespace === 'scp' && isSingleSource) {
                        const url = getRedirectLink(
                          null,
                          node.config.namespace === 'scp' ? node.config.datastakeId : null,
                          node.config.namespace === 'scl' ? `/view/scl/${node.config.datastakeId}/location` : null,
                          node.config.namespace,
                        );

                        if (mode === 'proxy') {
                          openDSWindow({
                            url,
                            name: `SCP Trade ${node.config.datastakeId}`,
                          });
                        } else {
                          const a = document.createElement('a');
                          a.target = '_blank';
                          a.rel = 'noopener noreferrer';
                          a.href = url;
                          a.click();
                        }
                      }
                    }
                  }
                }
              }}
            >
              <Controls>
                <ControlButton
                  onClick={() => flow === 'LR' ? setFlow('TB') : setFlow('LR')}
                >
                  {flow === 'TB' ? <RotateLeftOutlined /> : <RotateRightOutlined />}
                </ControlButton>
              </Controls>
              <Background color="black" gap={10} />
            </ReactFlow>
            {(activeNode && !isSingleSource) && (
              <Sider
                t={t}
                clear={clear}
                activeNode={activeNode}
                activeSources={activeSources}
                featuredData={featuredData}
                supplyChainActors={supplyChainActors}
                informationSources={informationSources}
                getRedirectLink={getRedirectLink}
              />
            )}
          </ReactFlowProvider>
        </Style>
      </ComponentWithFocus>
    </Widget>
  );
}
